import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';

@Component({
  selector: 'rn-coming-soon-banner',
  template: `
    @if (visible) {
      <div class="coming-soon-content">
        <mat-icon class="coming-soon-icon material-icons-outlined">info</mat-icon>

        <span class="coming-soon-message mat-headline-6">
          A new library experience is coming soon!
        </span>

        <a class="coming-soon-link mat-subtitle-2" href="https://www.simplicity-ils.com/coming-soon" target="_blank" rel="noopener noreferrer">
          Check it out!
        </a>

        <button mat-icon-button type="button" aria-label="Close announcement" (click)="onClickCloseButton()">
          <mat-icon class="coming-soon-icon">close</mat-icon>
        </button>
      </div>
    }
  `,
  styleUrl: './coming-soon-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatIconButton]
})
export class ComingSoonBannerComponent {
  public visible: boolean = true;  // Once the banner is dismissed, it will stay that way for the lifetime of the current instance of the app.

  public onClickCloseButton(): void {
    this.visible = false;
  }
}
